import { QueryClient } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { WhatsappTemplateDetail } from "modules/campaigns/components/Sections/channels/whatsapp/Editor/WhatsappDetail"
import { whatsappTemplateQuery } from "modules/campaigns/lib/templates/whatsapp/whatsappTemplateQuery"
import { Crumb } from "modules/shared/lib/breadcrumbs"

function getTemplateName(id: string, queryClient: QueryClient) {
  const template = queryClient.getQueryData(whatsappTemplateQuery({ id }).queryKey)
  if (template) return template.name

  return queryClient.fetchQuery(whatsappTemplateQuery({ id })).then((template) => template.name)
}

export const Route = createFileRoute("/_base/_auth/settings/channels/whatsapp/templates/$id")({
  component: WhatsappTemplateDetail,
  loader: ({ route: { fullPath }, params, context }) => {
    return new Crumb({
      fullPath,
      title: getTemplateName(params.id, context.queryClient),
    })
  },
})
